import {
  ContentCopy,
  Delete,
  Schedule,
} from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div style={{
      backgroundColor: "#ffffff",
      padding: "16px",
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      maxWidth: '320px',
      position: 'relative'
    }}>
      <Handle
        type="target"
        position="left"
        style={{
          background: "#8b5cf6",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      
      <div style={{
        display: "flex",
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        gap: 8
      }}>
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#8b5cf6' } }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <Schedule sx={{ width: "18px", height: "18px", color: "#8b5cf6" }} />
        <div style={{ color: "#111827", fontSize: "14px", fontWeight: 600 }}>
          Aguardar
        </div>
      </div>
      
      <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5', marginBottom: '4px' }}>
        <strong>Tempo:</strong> {data?.delaySeconds || 0}s
      </div>

      {data?.enableTimeout && (
        <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5' }}>
          <strong>Timeout:</strong> {data?.timeoutSeconds || 0}s
        </div>
      )}

      {!data?.enableTimeout && (
        <>
          {/* Saída Única (sem timeout) */}
          <Handle
            type="source"
            position="right"
            id="a"
            style={{
              background: "#8b5cf6",
              width: "12px",
              height: "12px",
              top: "50%",
              right: "-6px",
              cursor: 'pointer',
              border: '2px solid white'
            }}
            isConnectable={isConnectable}
          />
        </>
      )}

      {data?.enableTimeout && (
        <>
          {/* Saída Sucesso (usuário respondeu) */}
          <Handle
            type="source"
            position="right"
            id="success"
            style={{
              background: "#10b981",
              width: "12px",
              height: "12px",
              top: "35%",
              right: "-6px",
              cursor: 'pointer',
              border: '2px solid white'
            }}
            isConnectable={isConnectable}
          />

          {/* Saída Timeout (usuário não respondeu) */}
          <Handle
            type="source"
            position="right"
            id="timeout"
            style={{
              background: "#ef4444",
              width: "12px",
              height: "12px",
              top: "65%",
              right: "-6px",
              cursor: 'pointer',
              border: '2px solid white'
            }}
            isConnectable={isConnectable}
          />

          {/* Labels das saídas - dentro do node */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '8px',
            fontSize: '9px',
            fontWeight: 'bold'
          }}>
            <span style={{ color: "#10b981" }}>✓ Respondeu</span>
            <span style={{ color: "#ef4444" }}>✗ Não Respondeu</span>
          </div>
        </>
      )}
    </div>
  );
});
